// 微信信息
class WXInfo {
  unionId: string
  openId: string

  constructor(unionId: string, openId: string) {
    this.unionId = unionId
    this.openId = openId
  }
}

export default WXInfo
